import React from 'react';

import Text from '~/components/core/TextComponents/Text';
import cn from '~/Utils/cn';

/**
 * One grid template shared by the header and every row so the columns line up. The leading 24px
 * track is the drag handle; the trailing 90px is the actions cell. Placement is a conditional
 * track — the Policy tab has exactly one placement, so a column repeating it on every row would
 * carry no information.
 */
export const gridClassFor = (showPlacementColumn: boolean): string =>
  showPlacementColumn
    ? 'grid grid-cols-[24px_2fr_1.5fr_1fr_1.5fr_1.5fr_1.5fr_1fr_80px_90px] items-center gap-8'
    : 'grid grid-cols-[24px_2fr_1.5fr_1fr_1.5fr_1.5fr_1fr_80px_90px] items-center gap-8';

interface GlobalFieldsTableHeaderProps {
  showPlacementColumn: boolean;
}

const GlobalFieldsTableHeader: React.FC<GlobalFieldsTableHeaderProps> = ({ showPlacementColumn }) => {
  const headings = [
    '',
    'Display Name',
    'Key',
    'Type',
    'Context',
    ...(showPlacementColumn ? ['Placement'] : []),
    'Last Updated',
    'Updated By',
    'Enable',
    'Actions',
  ];

  return (
    <div className={cn(gridClassFor(showPlacementColumn), 'border-0 border-b border-solid border-slate-400 pb-8')}>
      {headings.map((heading, index) => (
        <Text
          // Headings are fixed and the empty drag-handle slot repeats no label, so index keys are
          // stable here.
          key={`${heading}-${index}`}
          variant={Text.VARIANTS.XS}
          weight={Text.WEIGHTS.SEMI_BOLD}
          colorVariant={Text.COLOR_VARIANTS.SECONDARY}
        >
          {heading}
        </Text>
      ))}
    </div>
  );
};

export default GlobalFieldsTableHeader;
